import { QueryClient } from '@tanstack/react-query';

/**
 * Invalidates all product-related queries to ensure data consistency across tabs.
 *
 * This should be called after any operation that modifies product data, such as:
 * - Product sync from WooCommerce
 * - Product creation, update, or deletion
 * - Bulk operations on products
 *
 * @param queryClient - The React Query client instance
 */
export function invalidateProductRelatedQueries(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: ['products'] });
  queryClient.invalidateQueries({ queryKey: ['stores'] });
  queryClient.invalidateQueries({ queryKey: ['seo-issues'] });
  queryClient.invalidateQueries({ queryKey: ['issue-stats'] });
  queryClient.invalidateQueries({ queryKey: ['priority-actions'] });
  queryClient.invalidateQueries({ queryKey: ['inventory-stats'] });
  queryClient.invalidateQueries({ queryKey: ['store-settings'] });
}
